
import { SmartAPIClass } from "@utilities/smart_api_class";

const API = (function() {
  let instance: SmartAPIClass;

  function createInstance() {
    return new SmartAPIClass();
  }

  return {
    getInstance: function() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();

export default API;
